import useDisplayDiets from "mt-components/hooks/useDisplayDiets";
import { DietaryRestriction } from "../../../graphql/operations";
import ToolTip from "../../Atoms/ToolTip";
import ListSection from "../ListSection";
import ToggleContentItem, {
  ToggleContentItemProps,
} from "../ToggleSection/ToggleContentItem";
import DietaryRow from "./DietaryRow";
import s from "./DietarySummaryCard.module.scss";

export type DietarySummaryCardProps = {
  dietaryRestrictions: DietaryRestriction[];
  containerStyle?: React.CSSProperties;
  dietaryStyle?: React.CSSProperties;
  allergenStyle?: React.CSSProperties;
  tableHeaderColor?: React.CSSProperties["color"];
  tableHeaderBackgroundColor?: React.CSSProperties["backgroundColor"];
} & Pick<ToggleContentItemProps, "withBorder" | "titleColor" | "titleSize">;

export default function DietarySummaryCard({
  allergenStyle,
  containerStyle,
  dietaryRestrictions,
  dietaryStyle,
  tableHeaderBackgroundColor = "#d81b60",
  tableHeaderColor = "white",
  titleColor,
  titleSize,
  withBorder,
}: DietarySummaryCardProps) {
  const { includedAllergens, sortedDiets } = useDisplayDiets({
    dietaryRestrictions,
  });

  return (
    <div className={s.Container} style={containerStyle}>
      {sortedDiets.length > 0 && (
        <ToggleContentItem
          title="Dietary Accommodation"
          style={dietaryStyle}
          titleColor={titleColor}
          titleSize={titleSize}
        >
          <p style={{ fontSize: 12, paddingBottom: "12px" }}>
            Inform us about any dietary preferences or restrictions in advance.
          </p>

          <table className={s.DietaryInformationTable}>
            <thead>
              <tr
                style={{
                  backgroundColor: tableHeaderBackgroundColor,
                  color: tableHeaderColor,
                }}
              >
                <th>Dietary request</th>
                <th>Availability</th>
              </tr>
            </thead>
            <tbody>
              {sortedDiets.map((diet) => (
                <DietaryRow key={diet.diet} dietaryRestriction={diet} />
              ))}
            </tbody>
          </table>
        </ToggleContentItem>
      )}
      <ToggleContentItem
        title="Included Allergens"
        withBorder={withBorder}
        style={allergenStyle}
        titleColor={titleColor}
        titleSize={titleSize}
      >
        <p style={{ fontSize: 12, paddingBottom: "12px" }}>
          We cannot be held responsible for any food allergens present at street
          food stalls during the tour.
        </p>

        {includedAllergens.length > 0 ? (
          <ListSection
            items={includedAllergens.map(({ diet, memo }) => (
              <div
                key={diet}
                style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
              >
                {diet.split("@")[1]}
                {memo && <ToolTip text={memo} />}
              </div>
            ))}
          />
        ) : (
          <p>No known allergens included</p>
        )}
      </ToggleContentItem>
    </div>
  );
}
